import { render, staticRenderFns } from "./WithoutCardsHeader.vue?vue&type=template&id=6094ba84&scoped=true&"
import script from "./WithoutCardsHeader.vue?vue&type=script&lang=ts&"
export * from "./WithoutCardsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./WithoutCardsHeader.vue?vue&type=style&index=0&id=6094ba84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094ba84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAppBar,VBtn,VCard,VCardText,VIcon,VImg,VMenu,VRadio,VRadioGroup,VSpacer,VSwitch})
